module.exports = __webpack_public_path__ + "4fc3a7bb406452ee6468b4d9af47fa63.svg";